import type { RouteRecordRaw } from 'vue-router'

/** Routes that must remain accessible without an authenticated staff session. */
export const publicRoutes: RouteRecordRaw[] = [
  {
    path: '/order',
    name: 'order-webview',
    // Dispatcher: có link_code → luồng bàn (OrderWebView), không link_code → storefront (StorefrontOrderView)
    component: () => import('@/views/pages/public/OrderEntryView.vue'),
    meta: {
      public: true,
      pageTitleKey: 'public.order.title',
    },
  },
]
